// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk~" + chunkId + "_" + "8252556ec2a4650d3ba8" + ".css";
};